export default __webpack_public_path__ + "static/media/PREMIOS IMPULSO SUME BY SAINT GOBAIN 2024 - Chapultepec UNO 509.85c31c81.pdf";